"use client";
import { CardTitle, Table } from '@develos/next-components';
import React from 'react';
import { VehicleRecordDetailsType } from '@/types';

type Props = {
  details: VehicleRecordDetailsType;
}

const AxelsTableContainer = ({ details }: Props) => {
  return (
    <>
      <div>
        <CardTitle title="Osie"/>
        <Table
          data={details.axleWeightsList.filter(x => x.axleWeight !== 0)}
          hidePagination={true}
          headers={['axleNumber', 'axleWeight', 'axleOverWeight', 'minAvailableWeight', 'maxAvailableWeight']}
          options={{ 
            filterable: null,
            sortable: ['axleNumber', 'axleWeight', 'axleOverWeight', 'minAvailableWeight', 'maxAvailableWeight'],
            headings: {
              axleNumber: 'Numer', 
              axleWeight: 'Nacisk', 
              axleOverWeight: 'Przeciążenie', 
              minAvailableWeight: 'Wart. min.', 
              maxAvailableWeight: 'Wart. maks.'
            }
          }}
        />
      </div>
      { details.axleGroups.length > 0 
          ? <div>
          <CardTitle title="Grupy osi"/>
          <Table
            data={details.axleGroups}
            hidePagination={true}
            headers={['weight', 'overWeight', 'minAvailableWeight', 'maxAvailableWeight']}
            options={{ 
              sortable: ['weight', 'overWeight', 'minAvailableWeight', 'maxAvailableWeight'],
              filterable: null,
              headings: {
                weight: 'Nacisk', 
                overWeight: 'Przeciążenie', 
                minAvailableWeight: 'Wart. min.', 
                maxAvailableWeight: 'Wart. maks.'
              }
            }}
          />
          </div>
        : '' }
    </>
  );
};

export default AxelsTableContainer;